module.exports = __webpack_public_path__ + "static/img/c20.63d5826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c20.png
// module id = 266
// module chunks = 0 1 2 3 4 5 6 7 8 9